
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import NewHeroSection from '@/components/NewHeroSection';
import NewServicesSection from '@/components/NewServicesSection';
import NewProjectsSection from '@/components/NewProjectsSection';
import NewContactForm from '@/components/NewContactForm';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';

const Index = () => {
  console.log('Index page rendering...');
  
  try {
    return (
      <>
        <Navbar />
        <main className="overflow-hidden bg-black">
          <NewHeroSection />
          <NewServicesSection />
          <NewProjectsSection />
          <NewContactForm />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </>
    );
  } catch (error) {
    console.error('Error rendering Index page:', error);
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Loading Error</h1>
          <p className="text-gray-400">There was an error loading the page. Please refresh.</p>
        </div>
      </div>
    );
  }
};

export default Index;
